import { getFieldAPI } from '../../utils/form_element_api_builder';

const parseFieldValue = (formAPI, $fieldId) => {
	const fieldId = $fieldId.replace(/^\$/, '');
	let fieldValue = getFieldAPI(formAPI, { fieldId }).value();
	if(!fieldValue && fieldValue !== 0){
		fieldValue = "";
	}

	if(Array.isArray(fieldValue)){
		fieldValue = fieldValue[0];
	}

	if((isNaN(fieldValue) || fieldValue == '') && fieldValue !==0) {
		fieldValue = `'${fieldValue}'`;
	}
	return fieldValue;
};

export const parse = (formAPI, script) => {
	return script.replace(/\$[A-Z0-9_]+/gi, parseFieldValue.bind(this, formAPI))
};

export default {
	parse,
};
